// extracted by mini-css-extract-plugin
export var attachment = "_iv-a";
export var emailContainer = "_iv-4";
export var emailContentPaddedContainer = "_iv-b";
export var emailHeader = "_iv-6";
export var emailIframe = "_iv-3";
export var emailInfoIcon = "_iv-9";
export var emailShortenedSummary = "_iv-e";
export var infoDropdown = "_iv-0";
export var infoRowBoundedContent = "_iv-d";
export var internal = "_iv-5";
export var merchant = "_iv-8";
export var messageInputContainer = "_iv-h";
export var normal = "_iv-7";
export var replyCard = "_iv-f";
export var subtleButton = "_iv-1";
export var subtleButtonIconContainer = "_iv-2";
export var toggleViewRepliesButton = "_iv-c";
export var wrappingText = "_iv-g";